import { render, staticRenderFns } from "./CarouselMoments.vue?vue&type=template&id=65be6175"
import script from "./CarouselMoments.vue?vue&type=script&lang=js"
export * from "./CarouselMoments.vue?vue&type=script&lang=js"
import style0 from "./CarouselMoments.vue?vue&type=style&index=0&id=65be6175&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports